import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { navigate, Link } from "gatsby"

import { createAlertURL, officesURL, contactURL } from "@lib/urls"

import { SearchType, siteName } from "@common/constant"
import { toCapitalize } from "@common/utils/site_utlis"
import SortBy from "../FilterBox/Sections/SortBy"

import "./PropertyInfo.scss"

const {
  createResultsUrl,
} = require("../../../gatsby-library-common/PropertySearchNew")

const PropertyInfo = ({
  searchState,
  algoliaData,
  sortBy,
  pathName,
  introText,
  metaIntro,
  loading,
  setShowMapView,
}) => {
  const [showInfo, setShowInfo] = useState(false)

  const handleSortBy = (val) => {
    // console.log("val==>", val)
    const searchParams = {
      ...searchState,
      sortVal: val,
      // areaVal: searchState.areaVal,
      // bedVal: searchState.bedVal,
      // minpriceVal: searchState.minpriceVal,
      // maxpriceVal: searchState.maxpriceVal,
      // buildingval: searchState.buildingval,
      // searchtypeVal: searchState.searchtypeVal,
      // srchTypeVal: searchState.searchtypeVal,
    }
    navigate(createResultsUrl(searchParams))
  }

  // eslint-disable-next-line no-unused-vars
  const mapViewNavigate = () => {
    const searchParams = {
      ...searchState,
      layout: "map-view",
    }
    navigate(createResultsUrl(searchParams))
  }

  const excludeSold = (event) => {
    let include_path = `${pathName}`
    if (event.target.checked) {
      if (pathName.endsWith("/")) {
        include_path = `${pathName}exclude-sold/`
      } else {
        include_path = `${pathName}/exclude-sold/`
      }
    } else {
      include_path = include_path.replace("exclude-sold/", "")
    }
    navigate(include_path)
  }

  const excludeLet = (event) => {
    let includePath = `${pathName}`
    if (event.target.checked) {
      if (pathName.endsWith("/")) {
        includePath = `${pathName}exclude-let/`
      } else {
        includePath = `${pathName}/exclude-let/`
      }
    } else {
      includePath = includePath.replace("exclude-let/", "")
    }
    navigate(includePath)
  }

  // const [state, setState] = useState(false)
  // console.log("searchState ==>", searchState)

  const action = SearchType[searchState.searchtypeVal].toLowerCase()

  let propTypeTxt = ""
  if (searchState?.departmentVal === "residential") {
    propTypeTxt = "properties"
  } else if (searchState?.departmentVal === "commercial") {
    propTypeTxt = "commercial properties"
  } else {
    propTypeTxt = "new developments"
  }
  // console.log("searchState=>", searchState)

  // const mapPath = pathName.replace("page-/", "")

  return (
    <section className="property">
      <Container>
        <Row>
          <Col>
            <div className="property-info">
              <h1>
                <span>
                  {algoliaData?.total > 0
                    ? parseInt(algoliaData?.total, 10)
                    : 0}{" "}
                  {introText}{" "}
                </span>
                <i
                  className="icon icon-info"
                  onClick={() => setShowInfo(!showInfo)}
                />
              </h1>

              <div className="sm-details">
                <div className="info-wrap">
                  <Link
                    to={createAlertURL}
                    className="map-info map-text create-alert d-md-flex"
                  >
                    <i className="icon-alert" />
                    Create alert
                  </Link>

                  <div className="divider" />

                  {searchState?.searchtypeVal === "sales" && (
                    <div className="checkbox-container include_checkbox d-none d-md-flex">
                      <label className="container-wrap">
                        <input
                          type="checkbox"
                          value="For Sale"
                          onChange={excludeSold}
                          checked={!!searchState?.excludeVal}
                        />
                        <span className="checkmark" /> Exclude Under offer, Sold
                      </label>
                    </div>
                  )}

                  {searchState?.searchtypeVal === "lettings" && (
                    <div className="checkbox-container include_checkbox d-none d-md-flex">
                      <label className="container-wrap">
                        <input
                          type="checkbox"
                          value="To Let"
                          onChange={excludeLet}
                          checked={!!searchState?.excludeVal}
                        />
                        <span className="checkmark" /> Exclude Let Agreed, Let
                      </label>
                    </div>
                  )}

                  <SortBy
                    selectOptions={sortBy}
                    sortByVal={searchState?.sortVal}
                    handleChange={handleSortBy}
                  />

                  {algoliaData?.total > 0 && (
                    <>
                      <div className="divider" />

                      <button
                        className="map-info map-text"
                        onClick={() => setShowMapView(true)}
                        type="button"
                      >
                        <i className="icon-map" />
                        Map<span>&nbsp;View</span>
                      </button>
                    </>
                  )}

                  {/* <Link
                    className="map-info grid-text d-none"
                    to={`${pathName}`}
                  >
                    <i className="icon-list" />
                    List View
                  </Link> */}
                </div>
              </div>

              {showInfo && (
                <p className="property-content">
                  Find the best {metaIntro} with{" "}
                  <Link to={`${officesURL}`}>{siteName} Estate Agents</Link>, or{" "}
                  <Link to={`${contactURL}`}>contact</Link> our property experts
                  and get help to find a property {action} in{" "}
                  {toCapitalize(searchState.areaVal)}.
                </p>
              )}

              {!loading &&
                (algoliaData?.total > 0 ? (
                  ""
                ) : (
                  <p className="property-content mt-5">
                    Unfortunately, we do not currently have any {propTypeTxt}{" "}
                    that match your search criteria.
                    <br />
                    <br />
                    We have selected some of our showcase {propTypeTxt} for you
                    to browse below. Alternatively, you can search again in the
                    bar above.
                  </p>
                ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default PropertyInfo
